import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Global styles first: page stylesheets (imported by the pages inside App) must come later in
// the bundle so their more specific rules win over the shared component styles.
import "./styles/tokens.css";
import "./styles/base.css";
import "./ui/ui.css";

import { App } from "./App";
import { canonicalUrl } from "./canonical";

const root = document.getElementById("root");
if (!root) throw new Error("index.html is missing #root");

// On an old Firebase address: go to the desk's real one before showing anything.
const moveTo = canonicalUrl(window.location);
if (moveTo) {
  window.location.replace(moveTo);
} else {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
